import styled from 'styled-components';

export const Wrapper = styled.div(({ theme: { size } }) => ({
  width: '100%',
  padding: `${size.units(1)} ${size.units(0.5)}`,
}));

export const Line = styled.div(({ theme: { color } }) => ({
  height: 1,
  width: '100%',
  backgroundColor: color.background.tertiary.default(),
}));
